import { IdentityType } from "graphql/generated/graphql";
import { capitalizeFirstLetterRestLowercase, getListFromGraphql } from "utils/utils";

const identityTypes: IdentityType[] = getListFromGraphql("IdentityType").filter(
    (type) => type !== "LDAP_CONFIG" && type !== "WORKSPACE"
);

// Identity types the "Add identity to the role" picker leaves out. Execution
// identities are transient. Flows, wrappers and schedulers are identities so
// their executions can carry roles, but their roles are managed on their own
// Roles tab; listing every flow here would bury the users and webhooks.
export const roleIdentityPickerExcludedTypes: IdentityType[] = ["EXECUTION", "FLOW", "WRAPPER", "SCHEDULER"];

export const roleIdentityPickerQueryField = {
    field: "identity_type",
    op: "notin",
    value: roleIdentityPickerExcludedTypes,
};

export const typeList = identityTypes.map((identity) => ({
    label: capitalizeFirstLetterRestLowercase(identity.replace("_", " ")),
    resourceName: identity.toLowerCase(),
}));

export const initialFilter = { identity_type: typeList.map((type) => type.resourceName) };

export const getInitialCountIri = (roleId: string) => `${roleId}-initialCount`;

// localStorage tableSettings key for the role identity list, so the page size
// persists across navigation and reload (parity with other record lists).
export const roleIdentityListKey = "roleIdentityList";
